// extracted by mini-css-extract-plugin
export default {"skeleton":"SignModalContent_skeleton__11hRx","checkbox":"SignModalContent_checkbox__ktKXw"};